import useIntersectionObserver from 'hooks/common/useIntersectionObserver';
import useLoginCheck from 'hooks/common/useLoginCheck';
import { getNotis } from 'lib/api/service/dashboard';
import { useInfiniteQuery } from 'react-query';

const useTempNotiListModal = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    error,
  } = useInfiniteQuery(
    ['serviceDashboardNotis'],
    ({ pageParam }) => getNotis({ pageParam, filter: 0 }),
    {
      getNextPageParam: lastPage => {
        if (!lastPage.isLast) return lastPage.nextPage;
        return undefined;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
      cacheTime: 0,
    },
  );
  useLoginCheck(error?.response, fetchNextPage);

  const onIntersection = entries => {
    const [entry] = entries;
    entry.isIntersecting && fetchNextPage();
  };

  const containerRef = useIntersectionObserver(onIntersection);

  return { data, hasNextPage, isFetchingNextPage, status, error, containerRef };
};

export default useTempNotiListModal;
